export const LIST_ADULT_EVALUATION = "LIST_ADULT_EVALUATION";
export const CREATE_ADULT_EVALUATION = "CREATE_ADULT_EVALUATION";
export const CREATE_REVIEW = "CREATE_REVIEW";
export const ADD_DELETE = "ADD_DELETE";
export const CHECK_ALL = "CHECK_ALL";
export const SHOW_ADULT_EVALUATION = "SHOW_ADULT_EVALUATION";
export const UPDATE_ADULT_EVALUATION = "UPDATE_ADULT_EVALUATION";
export const CHECK_INPUT_ITEM = "CHECK_INPUT_ITEM";
export const DATA_REMOVE_ADULTEVAL = "DATA_REMOVE_ADULTEVAL";
export const REMOVE_ADULT_EVALUATION = "REMOVE_ADULT_EVALUATION";
export const LIST_CLASSROOM = "LIST_CLASSROOM";
export const LIST_SUBJECT = "LIST_SUBJECT";
export const LIST_CLASSROOM_GROUP = "LIST_CLASSROOM_GROUP";
export const LIST_MODAL_CLASSROOM = "LIST_MODAL_CLASSROOM";
export const LIST_MODAL_SUBJECT = "LIST_MODAL_SUBJECT";
export const LIST_MODAL_CLASSROOM_GROUP = "LIST_MODAL_CLASSROOM_GROUP";
export const UPDATE_REVIEWS = "UPDATE_REVIEWS";